import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import { GENERAL_CONSTANTS, STATE } from "@/shared/constants/GeneralConstants";
import {
  SNACKBAR_STYLE,
  STYLE_CLASSES
} from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import { CHIP_FORM_CONSTANTS } from "./constants/ChipFormConstants";

@Component({
  name: "ChipFomList",
  components: { draggable }
})
export default class ChipFomList extends Vue {
  @Prop() formTemplates!: SectionGroupDetail[];
  @Prop({ default: () => false }) close!: boolean;
  @Prop({ default: () => false }) sort!: boolean;

  ICONS = GENERAL_CONSTANTS.ICONS;
  WARNING_COLOR = SNACKBAR_STYLE.WARNING.COLOR;

  ELEMENT_INACTIVE = STYLE_CLASSES.WARNING_TEXT_COLOR;
  STATE = STATE;

  get formTemplatesLocal() {
    return this.formTemplates;
  }

  set formTemplatesLocal(formtemplates: SectionGroupDetail[]) {
    this.$emit(CHIP_FORM_CONSTANTS.EMIT.UPDATE_FORM_TEMPLATES, formtemplates);
  }

  removeForm(e: number) {
    this.$emit(CHIP_FORM_CONSTANTS.EMIT.REMOVE_FORM, e);
  }
}
